import React from "react";
import { IState } from "../../../../../common/state/IState";
import { umSpPageStateSelector } from "../selectors";
import { ICustomerConfig } from "../../_features/loadDynamicContent/LoadDynamicContentModel";
import { useSelector } from "react-redux";

const i18n = {
    fullNamePlaceHolder: "full.name",
};

function selector(s: IState) {
    const umSpPageState = umSpPageStateSelector(s);
    return getFullName(
        umSpPageState?.auth?.user,
        umSpPageState?.dynamicContent?.config
    );
}

function getFullName(user: any, config: ICustomerConfig) {
    if (!user || !config) return i18n.fullNamePlaceHolder;

    return [
        config.firstNameField ? user[config.firstNameField] : null,
        config.lastNameField ? user[config.lastNameField] : null,
    ]
        .filter(x => x)
        .join(" ");
}

export const UmSpDcFullNameElement = ({ className }) => (
    <div className={className}>{useSelector(selector)}</div>
);
